import React from 'react';
import { Quote } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  name: string;
  title: string;
  avatar: string;
}

const Testimonial: React.FC<TestimonialProps> = ({ quote, name, title, avatar }) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-md transition-all hover:shadow-lg">
      <div className="mb-4 text-sage-500">
        <Quote className="h-8 w-8" />
      </div>
      <p className="text-gray-600 mb-6 italic">"{quote}"</p>
      <div className="flex items-center">
        <img 
          src={avatar} 
          alt={name} 
          className="w-12 h-12 rounded-full object-cover mr-4" 
        />
        <div>
          <h4 className="font-bold text-gray-800">{name}</h4>
          <p className="text-gray-500 text-sm">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;